(function() {
	// Load the script
	const script = document.createElement("script");
	script.src = (typeof jQuery =='undefined') ? 'https://code.jquery.com/jquery-3.6.0.min.js' : 'https://www.ytsubme.com/assets/js/sample.js';
	script.type = 'text/javascript';
	const params = new URLSearchParams(document.currentScript.src.split('?')[1]) 
	script.addEventListener('load', () => {
	(typeof Swal == 'undefined') ? $.getScript('//cdn.jsdelivr.net/npm/sweetalert2@11'): false;
	var cartURL = (typeof CartJS == 'undefined') ? "https://www.ytsubme.com/apps/pfandGonzo/home/assets/js/cart.min.js" : '/?cartJS=alreadyloaded'
	$.getScript(cartURL, function(data, textStatus, jqxhr) {
	  if (jqxhr.status == 200) {
		console.log('Deposit Fee loaded   0.35.99');
		// function showToast(icon, title, footer = null) {
		//   return Swal.fire({
		// 	icon: icon,
		// 	title: title,
		// 	footer: footer,
		// 	toast: true,
		// 	position: 'top-end',
		// 	showConfirmButton: false,
		// 	timer: 5000,
		// 	timerProgressBar: true,
		// 	didOpen: (toast) => {
		// 	  toast.addEventListener('mouseenter', Swal.stopTimer)
		// 	  toast.addEventListener('mouseleave', Swal.resumeTimer)
		// 	  toast.addEventListener('click', () => window.location.reload());
		// 	}
		//   });
  
		// }
		function getCartProducts() {					
		  var res = new Promise((rs, rj) => {
			$.ajax({
			  url: '/cart.js',
			  async: false,
			  dataType: 'JSON',
			  success: function(data) {
				// result = data;
				rs(data);
			  }
			});
  
		  });
  
		  return res;
		};
  
		function reloadCart() {
		  $('body').fadeOut(1000, () => jQuery.get('/cart').then((r) => {
		  $('body').fadeIn(1000, () => document.getElementsByTagName("html")[0].innerHTML = r)
		}));
	  }
  
	  function showLoader(method) {
		if (method == 'open') {
		  if(window.location.pathname.includes('/cart')){
			Swal.fire({
			  background: 'transparent',
			  allowOutsideClick: false,
			  showConfirmButton: false,
			  didOpen: () => {
			  Swal.showLoading()
			},
					  });
		  }
		}
		if (method == 'close') {
		  var appConfig = JSON.parse(localStorage.getItem('appConfig'));
		  Swal.close();
			if (window.location.pathname.includes('/cart')) {
				if (document.querySelectorAll('[name="update"]').length==0) { //reloading only when ajax update (auto-update) available on cart,else disabling since update is done via "update button"
					 if(appConfig.cartConfig.reloadOnUpdate){
                       setTimeout(()=>{window.location.reload()},1750)
                     };
			  	}
		  
		  }
		}
  
	  }
  
	  function CartLine(mode, Fee, handle, qty) {
		if (window.location.pathname.includes('/cart')) {
		  var stmt = '<p>' + Fee.fee_name + 'for' + handle + ' x ' + qty + '</p>';
		  var tag = document.getElementsByClassName('fd-pfand');
		  if (tag.length > 0) {
			if (mode == 'update') {
			  tag[0].innerHTML = '';
			}
			tag[0].innerHTML += stmt;
		  }
  
		}
  
	  }
	  function getLocConditions(dna){
		 var changeReq = true;
		if(dna.location){
		  changeReq = false;
		localStorage.setItem('locationFlag', false);
		}
		  if (changeReq == false) {
		  //  changeReq=false;
		  localStorage.setItem('locationFlag', true);
		}
		return changeReq;
	  }
	  function getCartConditions(dna) {
		var changeReq = true;
		if (dna.cart.cartqty === false) {
		  changeReq = false;
		  localStorage.setItem('cartFlag', false);
		  console.log('condiiton true for cartqty');
		}
		if (dna.cart.cartprice === false) { //meaning codition is  satisfied
		  changeReq = false;
		  localStorage.setItem('cartFlag', false);
		  //  console.log('condiiton true for cartprice',dna);
		}
		if (dna.cart.cartwt === false) {
		  changeReq = false;
		  localStorage.setItem('cartFlag', false);
		  console.log('condiiton true for cartwt');
		}
		if (changeReq == false) {
		  //  changeReq=false;
		  localStorage.setItem('cartFlag', true);
		}
		return changeReq;
	  }
  
	  function findMatch(array_1_small, array2_large) {
		var ary = new Array();
		for (i = 0; i < array2_large.length; i++) {
		  for (z = 0; z < array_1_small.length; z++) {
			if (array2_large[i] == array_1_small[z]) {
			  ary.push(i);
			}
		  }
  
		}
		return ary;
	  }
  
  
  
	  
	  function Init(Fee, dna,mode , cartitems, removeFee,conditionBook) {
        
		var appConfig = JSON.parse(localStorage.getItem('appConfig'))
	  	var checkOutBtn = (document.querySelectorAll(appConfig.btn.checkOutBtn));			  
		var containInCart = cartitems.some((e) => e.variant_id == Fee.variant_id);
		var myInit = new Promise((rs, rj) => {
		  var feeList = [];
		  if (dna.data.types.includes('product')) {
			var currentQty = qtyChangeCheck(Fee, cartitems);
			var totQty = (Fee.fee_feature.onetime === false) ? dna.result.result.reduce((a, c) => c.qty + a, 0) : 1;
			localStorage.setItem(Fee.variant_id, currentQty);
			var addFeeCheck = cartitems.every((ci)=>{
			  //  console.log('not2 addFeeCheck -'+Fee.handle,Fee.match);
			 
			  if(Fee.fee_match=='any'){
               
				var addFeeCheck = Fee.fee_condition.products.value.some((e)=>((e.prod.id==ci.product_id)));
				// console.log('not2 addFeeCheck -'+Fee.handle,addFeeCheck );         
			  }
			  if(Fee.fee_match=='all'){
				var addFeeCheck = (Fee.fee_condition.products.value.every((e)=>e.prod.id==ci.product_id));
			  }
				 if(ci.product_has_only_default_variant==false){
				  addFeeCheck = false;
				 return false;
				}
			  if(addFeeCheck){
				return false; // meaning the fee products are present and add the fee.
  
			  }
			  return true; // menaing - no fee product are present so dont add the fee.
			  localStorage.setItem(Fee.variant_id, currentQty);
			})
			var addFee = (!addFeeCheck)
		  
		  }
		  if (dna.data.types.includes('cart')) {
			var currentQty = ((Fee.fee_feature.onetime === false)) ? cartitems.reduce((a, c) => c.quantity + a, 0) : 1;
			var totQty = ((Fee.fee_feature.onetime === false)) ? cartitems.reduce((a, c) => c.quantity + a, 0) : 1;
			var addFeeCheck = false //later
			var addFee = (!addFeeCheck)
		  }
  
		  // console.log('totQty', totQty);
		  var fList = feeList.join(",").toString();
		  if (dna.result.result.length != 0) {
			dna.result.result.forEach((e, i) => {
			  feeList.push(dna.result.result[i].handle)
			  //CartLine(Fee,handle,qty,price) 
			});
		  }
  
		 
		  if (mode == 'update') {
			// console.log('flist', fList);
			if ((Fee.type == 'single')) {
			  if ((Fee.type == 'single') && (containInCart == false)) {
					  if (!Object.values(conditionBook).some(val => val === false)) {
				  console.log('Deposit Fee: everthing looks good ,no changes needed');
				  rs({
					done: true,
					response: 'Deposit Fee: everthing looks good ,no changes needed'
				  });
  
				} else {
				  if ((removeFee === false) && (localStorage.getItem(Fee.handle) == null)) {
					localStorage.setItem(Fee.handle, Fee.variant_id);
					CartJS.removeItemById(Fee.variant_id, {
					  "success": function(d, t, jhr) {
						CartJS.addItem(Fee.variant_id, totQty, {
						  "Fee": Fee.fee_name,
						  "On": fList,
						  "id":Fee.type,
  
						}, {
						  "success": function(d, t, jhr) {
							if (dna.data.types.includes('product')) {
							  localStorage.setItem(Fee.variant_id, currentQty);
							}
							if (dna.data.types.includes('cart')) {
							  var data = getCartConditions(dna);
							}
							if(dna.data.types.includes('location')){
								var data = getLocConditions(dna);
							}
							rs({
							  done: true,
							  response: 'Fee Added|Single|Update'
							});
  
						  }
						});
					  }
					})
				  }
				  // (dna.data.types.includes('product')) ? showLoader('open'): false;
  
				}
			  } else {
				(checkOutBtn.length >= 1) ? checkOutBtn.forEach((e) => setTimeout(()=>checkOutBtn.forEach((u) => u.removeAttribute('disabled')),1700)) : false;
  
				console.log('Skipping since contain in cart - fee' + Fee.type);
				//applyRules(Fee,cartitems, dna)
				if (dna.data.cart.cartprice.need != 0) {
				  if (localStorage.getItem('showToast') == null) {
					localStorage.setItem('showToast', true);
					//showToast('info', Fee.fee_name + ' added', 'Add products worth of ' + dna.data.cart.cartprice.need + Shopify.currency.active + ' to remove it')
  
				  }
				}
				rs({
				  done: true,
				  response: 'Fee Added|Single|Update'
				});
  
  
  
  
			  }
			}
			if ((Fee.type == 'multiple')) {
  
			  var currentQty = qtyChangeCheck(Fee, cartitems);
			  console.log('currentQty', currentQty);
			   console.log('condition', conditionBook);
			   if (!Object.values(conditionBook).some(val => val === false)) {
  
				// console.log('Deposit Fee: everthing looks good ,no changes needed');
				//  if(localStorage.getItem('sL')){localStorage.removeItem('sL');} //this wil make sure to show loader only once.
				rs({
				  done: true,
				  response: 'Deposit Fee: everthing looks good ,no changes needed'
				});
			  } else {
				//(dna.data.types.includes('product')) ? showLoader('open') : false; 
				  
				var bar = new Promise((resolve, reject) => {
			   var checkWrongProd = (dna.data.prod.wrongProdQTY) ? dna.data.prod.wrongProdQTY.filter((f)=>(f.fee_quantity !=f.linked_product_quantity) && (dna.data.satisfied)) : [];
				  if(checkWrongProd.length>=1){
				  dna.data.prod.FeeCartMap.forEach((e, index, array) => {
					if (e.fee_quantity != e.linked_product_quantity) {
                      if(e.fee_key){
                        console.log('Convickt', e);
                        
                      CartJS.updateItemQuantitiesById({[e.fee_key]:e.linked_product_quantity},
                                                     {
    "success": function(data, textStatus, jqXHR) {
      //if(appConfig.cartConfig.reloadOnUpdate ){setTimeout(()=>window.location.reload(),1600)};
      if(index==array.length-1)
		console.log('ConvictDNAReslve',dna);;
      resolve();
    }});
						  
						  
                      }else{
                        CartJS.removeItemById((e.fee_key) ? e.fee_key : e.fee_variant_id, {
						"success": function(d, t, jhr) {
						  console.log('Marshal',e);	
						   CartJS.addItem(e.fee_variant_id,e.linked_product_quantity,{"Fee":e.fee_name+ ' for '+e.linked_product_name,"id":e.linked_product});
						   if(index==array.length-1)
							 resolve();
						}
					  })
                      	
                      }

					  
					}
  
  
				  });
				  }else{resolve();}
				});
				var x = bar.then(() => {
					  //var cartHasDuplicateFeeID = ((new Set(dna.data.prod.FeeCartMap.map((v)=>v.fee_variant_id))).size == dna.data.prod.FeeCartMap.length) ? ;
					 rs({done: true,response: 'naruotd'});
			  });
  
  
  
  
			}
		  }
		}
		  if (mode == 'add') {
  
		  if((Fee.type == 'single')){
					  if ((addFee) && (containInCart == false) && (cartitems.length>=1)) {
  
			console.log('removeFee', removeFee);
			if ((removeFee === false) && (localStorage.getItem(Fee.handle) == null)) {
			  localStorage.setItem(Fee.handle, Fee.variant_id);
           
			  CartJS.removeItemById(Fee.variant_id, {
				"success": function(d, t, jhr) {
				  CartJS.addItem(Fee.variant_id, totQty, {
					"Fee": Fee.fee_name,
					"For": fList,
					"id":Fee.type,
				  }, {
					"success": function(d, t, jhr) {
					  // CartLine(mode,Fee,fList,totQty);
					  rs({
						done: true,
						response: 'Fee added|Single|ADD'
					  });
					  //showToast('success', Fee.fee_name + 'added to cart', 'click here to refresh your cart');
					  //reloadCart();
  
					}
				  });
  
				}
			  })
  
			} else {
			  console.log('Not addign fee since no product is added yet in cart and cart is empty')
			  rs({
				done: true,
				response: 'Fee added|Single|ADD',
				msg: 'Not addign fee since no product is added or fee condition is satisfied'
			  });
			}
  
  
  
		  } else {
			// console.log('Skipping since contain in cart - fee');
			//applyRules(Fee,cartitems, dna)
			if (dna.data.cart.cartprice.need != 0) {
			  if (localStorage.getItem('showToast') == null) {
				localStorage.setItem('showToast', true);
				//showToast('info', Fee.fee_name + ' added', 'Add products worth of ' + dna.data.cart.cartprice.need + Shopify.currency.active + ' to remove it');	
			  }
			}
			rs({
			  done: true,
			  response: 'Fee added|Single|ADD'
			});
		  }
		  
		  }
  
		  if ((Fee.type == 'multiple') && (addFee)) {
          //  alert('1');
		   var checkWrongProd = (dna.data.prod.wrongProdQTY) ? dna.data.prod.wrongProdQTY.filter((f)=>(f.fee_quantity !=f.linked_product_quantity) && (dna.data.satisfied)) : [];
				  if(checkWrongProd.length>=1){
				  dna.data.prod.FeeCartMap.forEach((e, index, array) => {
					if (e.fee_quantity != e.linked_product_quantity) {
					  CartJS.removeItemById((e.fee_key) ? e.fee_key : e.fee_variant_id, {
						"success": function(d, t, jhr) {
						  console.log('Marshal',e);	

						   CartJS.addItem(e.fee_variant_id,e.linked_product_quantity,{"Fee":e.fee_name+ ' for '+e.linked_product_name,"id":e.linked_product});
						   if(index==array.length-1)
							   rs({
						done: true,
						response: 'Fee added|Multiple|ADD'
					  });
						}
					  })
					  
					}
  
  
				  });
				  }
		  }
		}
  
  
		//  localStorage.removeItem('modeLock')
  
  
	  });
	  return myInit;
  
	}
  
	   function qtyChangeCheck(Fee, cartitems) {
  
	  var feeproductsvid = [];
	  var prodBlood = [];
	  cartitems.forEach((x) => {
  
		var res = feeitems.find((e) => {
		  var root = (e.prod.variants.find((e)=>e.id==x.variant_id));
  
		  if (root) {
			var newOBJ = {
			  [root.id]: (x.product_has_only_default_variant) ? x.quantity :(x.variant_title.match(/(\d+)/)) ? x.quantity*parseInt(x.variant_title.match(/(\d+)/)[1]) : x.quantity  
			}
			prodBlood.push(newOBJ);
			return e;
		  }
		})
		if (typeof res != 'undefined') {
		  feeproductsvid.push(res.prod.variants.find((e)=>e.id==x.variant_id).id);
  
		}
		console.log('res',res);
	  });
	  //console.log('prodBlood ',prodBlood);
	  //console.log('feeproductsvid',feeproductsvid);
	  var currentQty = cartitems.filter((e) => (e.id != Fee.variant_id) && (feeproductsvid.includes(e.variant_id))).reduce((a, c) => c.quantity + a, 0);
	  return currentQty;
  
	}
	//#2
	function getProductCondition(sF, cartitems) {
	  var feeProductsInCart = [];
	  var prodBlood = [];
		cartitems.forEach((x, index) => {
		var root = sF.fee_condition.products.value.find((e) =>(e.prod.variants.find((z)=>z.id==x.variant_id)));
	   // console.log('Root',root);
		//  console.log('RootItemnow ',x);
		  if(root){
		  
	if(sF.type=='multiple'){
						
						try {
					   //   alert(JSON.stringify(cartitems));
			  var Jumbo = cartitems.filter((z) => (z.product_type == 'deposit_fee') 
											
											// && (z.properties.Fee.includes(x.title.split(' ')[0]))
											&&(z.properties.id==x.id)
											);
  }
  catch(err) {
			var Jumbo = cartitems.filter((z) => (z.product_type == 'deposit_fee') 
											
											// && (z.properties.Fee.includes(x.title.split(' ')[0]))
										   // &&(z.properties.id==x.id)
											);
  }
	  
			  }
  
			  if(sF.type=='single'){
				var Jumbo = cartitems.filter((z) => (z.product_type == 'deposit_fee') 
											 //&& (z.properties.Fee.includes(x.title.split(' ')[0]))
											)                                  
				}
  
			  var FeeBride = Jumbo;
			  console.log('FeeBride', FeeBride);
			  //console.log('JumboRes',cartitems.filter((z) => (z.product_type == 'deposit_fee') && (z.properties.Fee.includes(x.title.split(' ')[0]))));
			  console.log('FeeBridexid', x.title);
			  
			  // cartitems.filter((e)=>(e.product_type=='deposit_fee') && (e.properties.Fee.includes('Alster Ale')))
			 if((!x.product_has_only_default_variant) && (FeeBride.length>1)){
			 // fee_qty = x.quantity*parseInt(x.variant_title.match(/(\d+)/)[1]);
				try {
				var  fee_qty=cartitems.find((nc) => (nc.variant_id == sF.variant_id) && (nc.properties.id==x.id)).quantity;
            
  }
  catch(err) {
	fee_qty=0;
   console.log( 'if any error, Code throws the error')
  }
				//alert(x.title+'should have'+fee_qty);
			  }else if(Jumbo.length>=1){
			//  alert(JSON.stringify(Jumbo))
			  fee_qty = sF.fee_feature.onetime ? 1 : Jumbo[0].quantity;
			  }else{
			  fee_qty =0; // meaning no fee is added to cart
			  }
			 console.log('FreeQTy',fee_qty);
            var feeInCartarr = cartitems.filter((f)=>(f.product_type=='deposit_fee') && (f.variant_id==sF.variant_id))
            //var feeInCartarr= cartitems.filter((e)=>((e.product_type=='deposit_fee') && (e.variant_id==sF.variant_id))).map((v)=>(v.properties.id) ? v.properties.id : false);
            if((feeInCartarr.length>=1) && ((x.product_type != 'deposit_fee'))){
             var feeInCart =  feeInCartarr.find((ff)=>{
                if((ff.properties.hasOwnProperty('id')) && (ff.properties.id==x.variant_id)){
              		return ff 
              }
              })
            	//var feeInCart = cartitems.find((xc) => sF.variant_id == xc.variant_id && xc.properties.hasOwnProperty('id') && feeInCartarr.includes(xc.properties.id));
            }
            console.log('hu',feeInCart,x.handle);
          
      //      var fee_fam = cartitems.find((e)=>((e.product_type !='deposit_fee') && (e.variant_id==feeInCart.properties.id)))
		//	  var fee_prod = (cartitems.filter((xc) => sF.variant_id == xc.variant_id && feeInCart.properties.id==fee_fam.variant_id));
            
				//(feeInCart) ? console.log('mkc',feeInCart.handle+'will be removed only'+'for prod'+feeInCart.properties.Fee) : false;
			  //FeeBride.forEach((n)=>{
			  
			   // if(n.variant_id == x.id){
			   x.feevariant_id = sF.variant_id;
              x.fee_key=(feeInCart) ? feeInCart.key : null;
            	x.feequantity = fee_qty;
			  x.fee_name=sF.handle;
			  feeProductsInCart.push(x);
		  }
		  });
	 
	  // const uniqueAddresses = prodBlood.filter((v,i,a)=>a.findIndex(v2=>(v2.fee_variant_id===v.fee_variant_id))===i)
  //const uniquefeeProductsInCart = [...new Map(feeProductsInCart.map((item, key) => [item[key], item])).values()]
	   feeProductsInCart.forEach((e) => {
         var linkQty  =  (sF.fee_feature.onetime === false) ? e.quantity : 1;
		var newOBJ = {
		  'fee_name':e.fee_name,
		  'fee_variant_id': e.feevariant_id,
          'fee_key':e.fee_key,
		  'fee_quantity': e.feequantity,
		  'fee_auto':sF.auto,
		  'linked_product_key':e.key,
		  'linked_product_name':e.title,
		  'linked_product': e.variant_id,
		  'linked_product_quantity': (e.product_has_only_default_variant) ? linkQty :(e.variant_title.match(/(\d+)/)) ? e.quantity*parseInt(e.variant_title.match(/(\d+)/)[1]) : linkQty,
		  'linked_product_has_only_default_variant':e.product_has_only_default_variant,
		  
		}
		prodBlood.push(newOBJ);
	  })
	  console.log('prodBlood', prodBlood);
	  //console.log('feeProductsInCart',feeProductsInCart);
	  return prodBlood;
	}
  
	//#1
	function applyFee(Fee, dna, mode, cartitems, removeFee, StoreFees) {
	  
	  var myFee = new Promise((rs, rj) => {
		if ((dna)) {

		  // conditionBook tells weather the conditon of any fee is not matching and change is required,so it add the value to False if change is required.
		  var conditionBook ={cart:null,product:null,location:null};
		  if (dna.data.types.includes('product')) {
			var totQty = (Fee.fee_feature.onetime == false) ? dna.result.result.reduce((a, c) => c.qty + a, 0) : 1;
			var prodCondition = getProductCondition(Fee, cartitems);
			var wrongProdQTY = prodCondition.filter((e) => e.fee_quantity != e.linked_product_quantity);
			var condition = ((wrongProdQTY.length >= 1)) ? false : true;
			var CDATA = wrongProdQTY;
			conditionBook.product = (condition);
		  }
		  if (dna.data.types.includes('cart')) {
			var currentQty = ((Fee.fee_feature.onetime == false)) ? cartitems.reduce((a, c) => c.quantity + a, 0) : 1;
			var totQty = ((Fee.fee_feature.onetime == false)) ? cartitems.reduce((a, c) => c.quantity + a, 1) : 1;
			var condition = (localStorage.getItem('cartFlag') == 'false') ? true : false;
			conditionBook.cart= (condition);
			var CDATA = null;
            

          
		  }
		  //console.log('conditon', condition);
			if (dna.data.types.includes('location')) {
			  var condition =(getLocConditions(dna)== false) ? true : false;
			 // console.log('Cart condition',condition);
			  conditionBook.location = (condition);
			var CDATA = null;
		  }
		  console.log('conditionBook',conditionBook);
	       		

		  if (Object.values(conditionBook).some(val => val === false)) {
            	
  //           if ((localStorage.getItem('sL') == null)) {
  //             showLoader('open');
  //             localStorage.setItem('sL', 'done');
  //           }
			// showLoader('open');
		   // console.log('Match',dna);
		  
			if (Fee.fee_match == 'any') {
              //console.log('shapoj',dna);
			  if ((dna.data.completed <= dna.data.conditions)) {
			  	
				Init(Fee, dna, mode, cartitems, removeFee,conditionBook).then((doneInit) => {
				  if (doneInit.done) {
					rs({
					  done: true,
					  msg:'The fee has NO satisfied the condition'
					});
				  }
				})
			  }
			}
  
			if (Fee.fee_match == 'all') {
			
			  if (dna.data.completed == dna.data.conditions) {
				
				Init(Fee, dna, mode, cartitems, removeFee,conditionBook, CDATA).then((doneInit) => {
				  if (doneInit.done) {
					rs({
					  done: true,
					   msg:'The fee has NO satisfied the condition'
					});
				  }
				});
			  }else{
					 rs({
					  done: false,
					  msg:'The fee has NO satisfied the condition'
					});
			  }
  
			}
		  } else {
		 //   console.log('arey bro all good');
			rs({
			  done: true,
			  msg:'The fee has satisfied the condition hence no changes needed',
			});
  
			//showLoader('close');
  
		  }
  
  
		}
  
	  });
	  return myFee;
	}
  
	function updateCart(item){
	jQuery.ajax({
	url: '/cart/change.js',
	type: 'post',
	dataType: 'json',
	data: {
	  id: item.key,
	  quantity: item.qty,
	  properties: item.property
	},
	success: function(cart){ alert('Done')}
  })
	}
	function applyRules(Fee, cartItems, dna) {
	  var myRules = new Promise((rs, rj) => {
		// showLoader('open');
		if (window.location.pathname.includes('/cart')) {
		  
					// var Disabling inputs/delete for Fee;
		  var id = Fee.variant_id;
		  if ($('form a[href*="' + id + '"]').parents('.cart-item').length >= 1) {
			var parent = $('form a[href*="' + id + '"]').parents('.cart-item');
            if(Fee.fee_feature.required){

			
            }
            if(Fee.fee_type=='percent'){
               var removePriceTxt  =  parent.find('[class*="price"]').remove();
              if(removePriceTxt.length==0){
                parent.find('td')[parent.find('td').length-1].innerHTML='';
                 parent.find('td')[parent.find('td').length-2].innerHTML='';
              }
               
           if(document.querySelectorAll('[data-subtotal]').length>=1){
                  
             var mf= theme.settings.moneyFormat;
             document.querySelectorAll('[data-subtotal]').forEach((z)=>{
               var getPrice = parseInt(localStorage.getItem('percent_totPrice')) + parseInt(localStorage.getItem('percent_'+Fee.variant_id));
               //alert(getPrice);
               var setPrice = mf.replace('{{amount}}',getPrice);
               z.innerHTML="<p>"+setPrice+"</p>";
             })
                  
              }
            }
            
		  }
		   else if ($('body').find('input[id*="' + id + '"],select[id*="' + id + '"]').length >= 1) {
             if(Fee.fee_feature.required){
                    var parent = $('body').find('input[id*="' + id + '"],select[id*="' + id + '"]');
		  			parent.siblings('button:lt(2)').attr('disabled', true);
             }
		  }
  
		
		   }
		  var removeFee = false;
		if ((dna.data.types.includes('cart')) && (removeFee==false)) {
		  // console.log('Cart: remove fee since its left alone')
		  if (dna.cart.cartprice === false) {
			  removeFee = true;

		  } else if (dna.cart.cartqty === false) {
  
			  removeFee = true;
		  } else if (dna.cart.cartwt === false) {
  
			  removeFee = true;
		  } else {
			if (window.location.pathname.includes('/cart')) {
			  removeFee = ((cartItems.length == 1) && (cartItems.some((e) => e.variant_id == Fee.variant_id))) ? true : false;
			}
		  }
		}
		 if ((dna.data.types.includes('location')) && (removeFee==false)) {
		  // console.log('Cart: remove fee since its left alone')
		  if (dna.location=== false) {
			  removeFee = true;

		  }
			 // console.log('removeFee', removeFee);
  
		}
	  
		if ((dna.data.types.includes('product')) && (removeFee==false)) {
			removeFee = ((dna.result.matchfound == 0)) ? true : false;
          if(!removeFee){
//           var feeInCart = cartItems.filter((cItem) => cItem.product_type == 'deposit_fee');
//       		feeInCart.forEach((fee)=>{
//               window.sF = StoreFees;
//        var multipleFee =  StoreFees.filter((f)=>f.type=='multiple').map((h)=>h.variant_id);
// 		if(((cartItems.find((ci)=>((multipleFee.includes(ci.variant_id)) && (typeof ci.variant_id ==fee.properties.id)))) == 'undefined')){
//             console.log('Exception','removed Fee for fee'+fee.handle);
// 			CartJS.removeItemById(fee.variant_id);
          
//         }
//       })
            
          }
		}
        
        console.log('mathe for fee'+Fee.handle,removeFee)
		//removing fee if none exists
		if (removeFee) {
		  //    console.log(cartItems)
		  if ((localStorage.getItem(Fee.handle))) {
			localStorage.removeItem(Fee.handle)
			localStorage.removeItem(Fee.variant_id);
		  }
		  if (cartItems.some((e) => e.variant_id == Fee.variant_id)) {
			cartItems.forEach((e,i,array) => {
			  console.log('Deposit Fee: Remove fee ' + e.handle + ' since the siblings does not exit');
			  if (e.variant_id == Fee.variant_id) {
				CartJS.removeItemById(e.variant_id, {
				  "success": function(d, x, hr) {
				  if(i==array.length-1)
					rs({
					  done: true,
					  response: removeFee
					});
				  }
				})
			  } else {
				rs({
				  done: true,
				  response: removeFee,
				  msg: 'Fee doest not containt in cart'
				});
			  }
			})
		  } else {
			rs({
			  done: true,
			  response: removeFee,
			  msg: 'Fee doest not containt in cart'
			});
		  }
		  //CartJS.removeItemById(12345678);
		} else {rs({
			done: true,
			response: removeFee,
			msg: 'No changes to Fee which is added'
		  });}
  
  
  
	  });
  
	  return myRules;
	} //apply features
	function getMatchedProducts(feeitems, cartitems, Fee) {
	  var prodCondition = getProductCondition(Fee, cartitems);
	  
	  var wrongProdQTY = prodCondition.filter((e) => e.fee_quantity != e.linked_product_quantity);
	  var CDATA = wrongProdQTY;
  
	  window.feeitems = feeitems;
	  window.cartitems = cartitems;
	  var matchObj = [];
	  
	  var res = cartitems.filter(function (o1) {
	 
	  return feeitems.some(function (o2) {
		  return o2.prod.variants.map((e)=>e.id).includes(o1.variant_id);
		   // return the ones with equal id
	 });
	  });
	  res.forEach((ci,i)=>{
			  matchObj.push({
			  matchfound: true,
			  variant_id: ci.variant_id,
			  root:ci,
			  handle: ci.handle,
			  product_title:ci.product_title,
			  qty: ci.quantity, //the fee should increase by this qty match the cart qty of thart product.
			  price: ci.price,
			  wrongProdQTY: wrongProdQTY.find((e) => e.linked_product == ci.id),
			});
	  })
	  return {
		'matchfound': matchObj.length, //how many products?
		'result': matchObj //products which match the fee conditions and are to be added.
	  };
	} //get cart items = fee items
	//#3 this is runned two times
	function applyMatch(CartProducts, Fee) {
      var haltCode =false;
	 // console.log('Onetime',Fee);
	  var myMatch = new Promise((rs, rj) => {
        	
		 var matchedProducts = (Fee.fee_condition.products)?  getMatchedProducts(Fee.fee_condition.products.value, CartProducts.items,Fee) :{
		'matchfound':0, //how many products?
		'result':[] //products which match the fee conditions and are to be added.
	  };
		  var matchResult = {
			product: null,
			cart: {
			  cartprice: null,
			  cartwt: null,
			  cartqty: null
			},
			location: null,
			customer: null,
			result: matchedProducts,
			data: {
			  conditions: 0,
			  completed: 0,
			  match:Fee.fee_match,
			  satisfied:null,
			  types: [],
			  prod: {
				wrongProdQTY: null,
				FeeCartMap: null,
			  },
			  cart: {
				cartprice: {
				  totPrice: null,
				  need: 0,
				  fee_variant_id:null
				},
                cartqty: {
				  totQty: null,
				  need: 0,
				  fee_variant_id:null
				}
			  },
              customer:{
                tags:null,
                result:false,
                need:0,
                fee_variant_id:null
              }
			}
		  };
		  if (Fee.fee_condition.products.enabled) {
			matchResult.data.types.push('product');
			var prodCondition = getProductCondition(Fee, CartProducts.items);
            console.log('afterclickcount',CartProducts.items)
			var wrongProdQTY = prodCondition.filter((e) => (Fee.type=='multiple') && (e.fee_quantity != e.linked_product_quantity));
		   // console.log('Node 1');
			var CDATA = wrongProdQTY;
			matchResult.data.prod.wrongProdQTY = wrongProdQTY; //products with wront qty and need to be fixed
			matchResult.data.prod.FeeCartMap = prodCondition; //used for multiple - update
			matchResult.data.conditions++;
			if (matchedProducts.matchfound) {
			  matchResult.data.completed++;
			  matchResult.product = true;
			  
  
			} else {
			  matchResult.product = false;
			}
  
		  }
		  if (Fee.fee_condition.cart.enabled) {
			matchResult.data.types.push('cart');
			if ((Fee.fee_condition.cart.value.cartprice.enabled)) {
			  // console.log(CartProducts)
			  var priceExcl = CartProducts.items.find((e) => e.variant_id == Fee.variant_id);
              //console.log('priceexcl',priceExcl)
			  var totPrice = (priceExcl) ? (CartProducts.total_price / 100) - ((priceExcl.quantity) * (priceExcl.final_price / 100)) : (CartProducts.total_price / 100);
			  var needPrice = parseInt(((Fee.fee_condition.cart.value.cartprice.value) - totPrice).toFixed(2));
	
			  matchResult.data.cart.cartprice.totPrice = totPrice;
			  matchResult.data.cart.cartprice.need = (Math.sign(needPrice) == -1)? 0 :needPrice;
			  matchResult.data.cart.cartprice.fee_variant_id=Fee.variant_id;
			  matchResult.data.cart.cartprice.fee_name=Fee.handle;
              matchResult.data.cart.cartprice.result=false; //tells weather the cartprice fee should be added or not,default = not add;
			  matchResult.data.conditions++;

			  switch (Fee.fee_condition.cart.value.cartprice.operator) {
				case '=':
				   matchResult.data.cart.cartprice.result=matchResult.cart.cartprice = ((Fee.fee_condition.cart.value.cartprice.value == totPrice)) ? true : false;
				  (matchResult.cart.cartprice) ? matchResult.result.matchfound++: false;
				  
				  break;
				case '<':
				  matchResult.data.cart.cartprice.result= matchResult.cart.cartprice = ((Fee.fee_condition.cart.value.cartprice.value > totPrice)) ? true : false;
                	
				  (matchResult.cart.cartprice) ? matchResult.result.matchfound++: false;
                  
                  
				  //  console.log('Fee.fee_condition.cart.value.cartprice.value',Fee.fee_condition.cart.value.cartprice.value);
				  // console.log('CartProducts.total_price',CartProducts.total_price/100);
				  break;
				case '>':
				   matchResult.data.cart.cartprice.result=matchResult.cart.cartprice = ((Fee.fee_condition.cart.value.cartprice.value < totPrice)) ? true : false;
				  (matchResult.cart.cartprice) ? matchResult.result.matchfound++: false;
  					
				  break;
			  }
              
			  (matchResult.cart.cartprice) ? matchResult.data.completed++: false;
			}
			if ((Fee.fee_condition.cart.value.cartqty.enabled)) {
              var priceExcl = CartProducts.items.find((e) => e.variant_id == Fee.variant_id);
              var nonPfandQty = CartProducts.items.filter((z)=>z.product_type!='deposit_fee').reduce((a,c)=>a+c.quantity,0);
              var totQty = (priceExcl) ? CartProducts.items.reduce((a,c)=>a+c.quantity,0) : false;
			  var needQty=  Fee.fee_condition.cart.value.cartqty.value - totQty ;

              matchResult.data.cart.cartqty.totQty = totQty;
			  matchResult.data.cart.cartqty.need = needQty;
			  matchResult.data.cart.cartqty.fee_variant_id=Fee.variant_id;
			  matchResult.data.cart.cartqty.fee_name=Fee.handle;
              matchResult.data.cart.cartqty.result=false; //tells weather the cartqty fee should be added or not,default = not add;
			  matchResult.data.conditions++
             
              ///console.log('Tinku',Fee.fee_condition.cart.value.cartqty.operator,Fee.fee_condition.cart.value.cartqty.value,nonPfandItems.length,CartProducts);
			  switch (Fee.fee_condition.cart.value.cartqty.operator) {
                
				case '=':
				  matchResult.data.cart.cartqty.result= matchResult.cart.cartqty = ((Fee.fee_condition.cart.value.cartqty.value == nonPfandQty)) ? true : false;
				  (matchResult.cart.cartqty) ? matchResult.result.matchfound++: false;
				  break;
				case '<':
				  matchResult.data.cart.cartqty.result=  matchResult.cart.cartqty = ((Fee.fee_condition.cart.value.cartqty.value > nonPfandQty)) ? true : false;
				  (matchResult.cart.cartqty) ? matchResult.result.matchfound++: false;
				  break;
				case '>':
				  matchResult.data.cart.cartqty.result=  matchResult.cart.cartqty = ((Fee.fee_condition.cart.value.cartqty.value < nonPfandQty)) ? true : false;
				  (matchResult.cart.cartqty) ? matchResult.result.matchfound++: false;
				  break;
			  }
			  (matchResult.cart.cartqty) ? matchResult.data.completed++: false;
			}
  
			if ((Fee.fee_condition.cart.value.cartwt.enabled)) {
			  matchResult.data.conditions++
			  switch (Fee.fee_condition.cart.value.cartwt.operator) {
				case '=':
				  matchResult.cart.cartwt = ((Fee.fee_condition.cart.value.cartwt.value == CartProducts.total_weight)) ? true : false;
				  (matchResult.cart.cartwt) ? matchResult.result.matchfound++: false;
				  break;
				case '<':
				  matchResult.cart.cartwt = ((Fee.fee_condition.cart.value.cartwt.value < CartProducts.total_weight)) ? true : false;
				  (matchResult.cart.cartwt) ? matchResult.result.matchfound++: false;
				  break;
				case '>':
				  matchResult.cart.cartwt = ((Fee.fee_condition.cart.value.cartwt.value > CartProducts.total_weight)) ? true : false;
				  (matchResult.cart.cartwt) ? matchResult.result.matchfound++: false;
				  break;
			  }
			  (matchResult.cart.cartwt) ? matchResult.data.completed++: false;
			}
		  }
		  if (Fee.fee_condition.location.enabled || ((Fee.fee_condition.location.hasOwnProperty('value')) && (Fee.fee_condition.location.value.length>=1))) {
			matchResult.data.types.push('location');
			matchResult.data.conditions++
			//https://ipapi.co/json/
		 //   console.log('Location enabled');
			if(localStorage.getItem('user')==null){
			  fetch('https://api.ipdata.co/?api-key=45c2f85345809d9fa4773b7343054cb842f9f4c52944a55e56fc3f22').then((r) => r.json()).then((r) => {
			  localStorage.setItem('user',JSON.stringify(r));
			});
			}	if(localStorage.getItem('user')){
				  var r = JSON.parse(localStorage.getItem('user'))
			  matchResult.location = ((Fee.fee_condition.location.value.some((c) => (c.code == r.country_code) || (r.currency.code == Shopify.currency.active) ))) ? true : false;
			  (matchResult.location) ? matchResult.data.completed++: false;
			  (matchResult.location) ? matchResult.result.matchfound++: false;
			}else{
			matchResult.location=false;
			}	
		  }
		  if (Fee.fee_condition.customer.enabled && __st.hasOwnProperty('cid')) {


			  matchResult.data.types.push('customer');
			  matchResult.data.conditions++
			  //{"shop":"noorani-trading-inc.myshopify.com","cid":"6036350992566","method":"getCustomer"}
              if(true || localStorage.getItem('stCid')==null){
              				  postData('https://flydiz.com/apps/depositfee/home/class/controller.php', {
                                shop: Shopify.shop,
                                method: 'getCustomer',
                                cid:__st.cid,
                              }).then((r)=>{
								  if (r.response_code) {
                                    localStorage.setItem('stCid',JSON.stringify(r.response))
								  }
                              });
              }
            if(localStorage.getItem('stCid')){
              var localres =  JSON.parse(localStorage.getItem('stCid'))
              var tagString =  localres.tags;
              var tags = tagString.split(',').map((z) => z.trim())
              matchResult.data.customer.tags = tags;
			  matchResult.data.customer.need = Fee.fee_condition.customer.value;
			  matchResult.data.customer.fee_variant_id=Fee.variant_id;
			  matchResult.data.customer.fee_name=Fee.handle;
              matchResult.data.customer.result = matchResult.customer = (tags.includes(Fee.fee_condition.customer.value)) ? true : false;
              (matchResult.customer) ? matchResult.data.completed++: false;
              (matchResult.customer) ? matchResult.result.matchfound++: false;
              
              
            }else{
            matchResult.customer = false;
            }
		  }
        
		  matchResult.data.satisfied= (Fee.fee_match=='all' && (matchResult.data.conditions==matchResult.data.completed)) ? true : (Fee.fee_match=='any' && (matchResult.data.completed) && (matchResult.data.completed<=matchResult.data.conditions)) ? true :false;
		   var Jarix=(matchResult);
			 console.log('Jarix',Jarix)
          rs({
			done: true,
			response: Jarix
		  });
		});
  
	 
	
	  return myMatch;
  
	} //apply the conditions 
	async function postData(url = '', data = {}) {
	  // Default options are marked with *
	  const response = await fetch(url, {
		method: 'POST', // *GET, POST, PUT, DELETE, etc.
		mode: 'cors', // no-cors, *cors, same-origin
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		credentials: 'same-origin', // include, *same-origin, omit
		headers: {
		  'Content-Type': 'application/json'
		  // 'Content-Type': 'application/x-www-form-urlencoded',
		},
		redirect: 'follow', // manual, *follow, error
		referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
		body: JSON.stringify(data) // body data type must match "Content-Type" header
	  });
	  return response.json(); // parses JSON response into native JavaScript objects
	}
	function appConfig(config=null){
	  var checkOutBtn = (config && config.checkOutBtn) ? config.checkOutBtn : '[name="checkout"],[data-testid="Checkout-button"],[class*="checkout"]'; //node
	  var addToCartBtn=(config && config.addToCartBtn) ? config.addToCartBtn :null;
	  var cartItem=(config && config.cartItem) ? config.cartItem : '[class$="-item"],[class$="item"]',//node
		  toast = {
			enabled:(config && config.toast) ? config.toast : true,
			position:(config && config.toast) ? config.toast : 'top-end',
		  } //config
	  var loaderBar={
		'title':(config && config.loaderBar.title) ? config.loaderBar.title : null  ,
		'text':(config && config.loaderBar.text) ? config.loaderBar.text : null  ,
		'footer':(config && config.loaderBar.footer) ? config.loaderBar.footer : null  ,
		imageUrl: (config && config.loaderBar.imageUrl) ? config.loaderBar.imageUrl : null  ,
		imageHeight: (config && config.loaderBar.imageHeight) ? config.loaderBar.imageHeight: 80,
	  }
	  var cartConfig={
		hideFeeCart:false,//true only when cartItemNodee is set
		reloadOnUpdate:true,
  
	  }      
	  return {btn:{checkOutBtn:checkOutBtn,addToCartBtn:addToCartBtn},toast:toast,loaderBar:loaderBar,cartItem:cartItem,cartConfig:cartConfig}
	}
function startEngine(CartProducts, Fee,index,StoreFees,resolve){
  var packet = [];
  var refreshBoard = [];
  var containInCartBoard = [];
	applyMatch(CartProducts, Fee).then((r) => {
				if (r.done) {
				  var dna = r.response;
				  applyRules(Fee, CartProducts.items, dna).then((r) => {
					if (r.done) {
					 
					  var removeFee = r.response;
					  var feeInCartAlready  = CartProducts.items.some((e) => e.variant_id == Fee.variant_id);
					  var containInCart = (feeInCartAlready) ? true : false;
					  if (containInCart) {
                        
						var addedFee = applyFee(Fee, dna, 'update', CartProducts.items, removeFee, StoreFees).then((y) => {
						  if(y.done){
						  
						  if (index === StoreFees.length - 1) {
							packet.push(true);
							//(checkOutBtn.length >= 1) ? checkOutBtn.forEach((e) => e.removeAttribute('disabled')): false;
							resolve({
							  done: true,
							  dna: dna,
							  feeInCart: containInCart,
							  refresh: refreshBoard,
							  fees:StoreFees,
							  rF:removeFee
							});
						  } else {
							packet.push(false);
							resolve({
							  done: true,
							  dna: dna,
							  feeInCart: containInCart,
							  refresh: refreshBoard,
							  fees:StoreFees,
							  rF:removeFee
  
							});
						  }
						  if(Fee.type=='multiple'){
							((dna.data.prod.wrongProdQTY.length == 0) || (localStorage.getItem('cartFlag')) ||(localStorage.getItem('locationFlag')) ) ? refreshBoard.push(false): refreshBoard.push(true);
							console.log('update-checker for Fee:' + Fee.handle, packet);
							packet.push(false);
							resolve({
							  done: true,
							  dna: dna,
							  feeInCart: containInCart,
							  refresh: refreshBoard,
							  fees:StoreFees,
							  rF:removeFee
  
							});
						  }
  
						  }else{
							  resolve({
							  done: true,
							  dna: dna,
							  feeInCart: containInCart,
							  refresh: refreshBoard,
							  fees:StoreFees,
							  rF:removeFee,
								msg:'No condition satisfied'
							});
						  }
						});
					  } else {
						var addedFee = applyFee(Fee, dna, 'add', CartProducts.items, removeFee, StoreFees).then((y) => {
						  if(y.done){
							
						  if(Fee.type=='multiple'){
							((dna.data.prod.wrongProdQTY.length == 0) || (localStorage.getItem('cartFlag')) ||(localStorage.getItem('locationFlag')) ) ? refreshBoard.push(false): refreshBoard.push(true);
							console.log('add-checker for Fee:' + Fee.handle, packet);
						  }
												 if (index === StoreFees.length - 1) {
							packet.push(true);
							//(checkOutBtn.length >= 1) ? checkOutBtn.forEach((e) => e.removeAttribute('disabled')): false;
							resolve({
							  done: true,
							  dna: dna,
							  feeInCart: containInCart,
							  refresh: refreshBoard,
							  fees:StoreFees,
							  rF:removeFee
							});
						  } else {
							packet.push(false);
							resolve({
							  done: true,
							  dna: dna,
							  feeInCart: containInCart,
							  refresh: refreshBoard,
							  fees:StoreFees,
							  rF:removeFee
							});
						  }
  
						  }else{
													resolve({
							  done: true,
							  dna: dna,
							  feeInCart: containInCart,
							  refresh: refreshBoard,
							  fees:StoreFees,
							  rF:removeFee,
													  msg:'No condition met',
		 
							 
							});
						  }
   
						});
					  }
					}
  
				  });
				}
			  });

}
function checker(StoreFees) {
	 // console.log('Checker - LS',localStorage.getItem('isProdFee')) 
	  showLoader('open');
      var appConfig = JSON.parse(localStorage.getItem('appConfig'))
	  var checkOutBtn = (document.querySelectorAll(appConfig.btn.checkOutBtn));
	  getCartProducts().then((r) => {
		var CartProducts = r;
//         var nonsF =CartProducts.items.filter((r)=> r.product_type != 'deposit_fee');
//         var nonsFPrice = nonsF.reduce((a,c)=>a+(c.price*c.quantity),0);
//      	var totPrice = ((nonsFPrice)/100);
		var bar = new Promise((resolve, reject) => {
		  StoreFees.forEach((Fee, index, array) => {
		console.log('Fee',StoreFees)
			if ((Fee.status == 'active')) {
           if(Fee.fee_type=='percent'){
             updatePercentFee(Fee,CartProducts.items).then((x)=>{
             
				startEngine(CartProducts, Fee,index,StoreFees,resolve)
              });
           }else{
           startEngine(CartProducts, Fee,index,StoreFees,resolve);
             
           }
			}
		  }); //en
		});
		bar.then((bd) => {
		  console.log('bd', bd);
		  if (!bd.refresh.includes(true)) {
             //this loop hapens when fees are not matching
              showLoader('close');
			console.log('All done!', bd);
			if(window.location.pathname.includes('/cart')){
			  bd.fees.every((Fee)=>{          

            
		 
				var containInCart = CartProducts.items.some((e) => e.variant_id == Fee.variant_id);
				if(containInCart){
				  if(document.querySelectorAll('form a[href*="'+Fee.handle+'"]').length==0){
					showLoader('open');
					console.log('Exception:Fee contains in cart & is NOT visible for Fee with variant' +Fee.variant_id);
						window.location.reload();
					return false
					//console.log('raka',document.querySelectorAll('form a[href*="'+Fee.variant_id+'"]'))
				  }
				}else if(document.querySelectorAll('form a[href*="'+Fee.variant_id+'"]').length>=1){
				  showLoader('open');
				 console.log('Exception: Fee does not contain in cart & is  visible for Fee with variant' +Fee.variant_id);
				  window.location.reload();
				  return false;
				}else{
				  return true;
  
				} 
			  });
            //cleaner(StoreFees,CartProducts.items);
			}
			if ((localStorage.getItem('isProdFee')) && ((localStorage.getItem('isProdFee').split(',').includes('true'))) || (window.location.pathname.includes('/cart'))) {
              if (document.querySelectorAll('[name="update"]').length>0){
                (checkOutBtn.length >= 1) ? checkOutBtn.forEach((e) => e.disabled=true) : false;
                console.log('nk:Diasbaled checkoutbtn-since update btn is present-Stop customer to checkout'); //fix - when click on checkout shopify moves with current outdated cart items,making pfand not work;
              }else{
                (checkOutBtn.length >= 1) ? checkOutBtn.forEach((e) => e.removeAttribute('disabled')) : false;
                console.log('nk:Allowed checkoutbtn');
              }
			  
		   
			} 
		   
		  } else {
            //if(bd.dna.data.types.includes('product')){
             console.log('Reloading since not done!', bd);
            
             //StoreFees.forEach((Fee, index, array) =>lastCheck(Fee,r.items,bd.dna));
		   	if(appConfig.cartConfig.reloadOnUpdate ){setTimeout(()=>window.location.reload(),1200)};
          //  }
		   
		  }
  
		  // console.log('All done!',bd);
		});
  
	  })
	}
	function manualFee(sF,CartProducts) {
					  var manaulsF = sF.filter((x) => !x.auto)
                      var nonsF =CartProducts.items.filter((r)=> r.product_type != 'deposit_fee');
      				  var nonsFPrice = nonsF.reduce((a,c)=>a+(c.price*c.quantity),0);
      				 // var nonsFQty = (nonsF.reduce((a,c)=>a+c.quantity,0));
      				  var totPrice = ((nonsFPrice)/100);
      				 
					  if (manaulsF) {
						  manaulsF.forEach((e, i) => {
                            var el = document.querySelector('#pfand_' + e.handle);
                             var priceTXT = '<span> ('+(e.fee_price) + Shopify.currency.active+') </span>';
                            if(e.fee_type=='percent'){
                              var priceTXT = '<span> ('+((e.fee_price/100)*(totPrice)).toFixed(2) + Shopify.currency.active+') </span>';
                              var parent = $('form a[href*="' +e.variant_id+ '"]').parents('[class$="-item"],[class$="item"],[class*="row"],[id^="item"]')
                                parent.find('[class*="price"]').remove();
                              postData('https://flydiz.com/apps/depositfee/home/class/controller.php', {
                                shop: Shopify.shop,
                                method: 'updateProd',
                                pvid:e.variant_id,
                                price:(e.fee_price/100)*(totPrice),
                              }).then((x)=>{
                                
                                localStorage.setItem('percent_'+e.variant_id,x.price);
                               // startEngine(cartitems,sF,i,resolve)
                              });
                            }
							  if (el) {
                               if(CartProducts.items.some((z)=>z.id== e.variant_id && z.product_type == 'deposit_fee')){
                              	el.setAttribute('checked',true)
                              	}
								  el.setAttribute('prod', e.variant_id);
                                	el.parentElement.insertAdjacentHTML('beforeend',priceTXT);
								  el.addEventListener('change', e => {
  
									  if (e.target.checked) {
										CartJS.addItem(el.getAttribute('prod'), 1, {"id":el.getAttribute('prod')}, {
											  "success": function(data, textStatus, jqXHR) {
												  window.location.reload();
											  },
											  "error": function(jqXHR, textStatus, errorThrown) {
												  alert('Error: ' + errorThrown + '!');
											  }
										  });
                                      }else{
                                        CartJS.updateItemById(el.getAttribute('prod'),0,{},{
                                        "success": function(data, textStatus, jqXHR) {
												  window.location.reload();
											  }
                                        });
                                       
                                      }
  
								  });
  
							  }
  
  
						  })
  
					  }
				  }
	function checkProdFee(dna,StoreFees,CartProducts){
  
	  var logger = new Promise((resolve,reject)=>{
		var prodFeeResult = [];
		StoreFees.forEach((Fee,index,array) => {
		  if (localStorage.getItem(Fee.variant_id)) {
			localStorage.removeItem(Fee.variant_id)
		  } //this remove all fee LS
  
		  if (CartProducts.items.find((e) => e.variant_id == Fee.variant_id)) { // if the cart on reload contains fee already;
  
		  } else {
			(localStorage.getItem(Fee.handle)) ? localStorage.removeItem(Fee.handle): false;
		  }
		  if (dna.data.types.includes('product')) {
			var ProdFeeCheck = ((ShopifyAnalytics) && (ShopifyAnalytics.meta.hasOwnProperty('product'))) ? Fee.fee_condition.products.value.find((e) => e.prod.id == ShopifyAnalytics.meta.product.id) : undefined;
			if (typeof ProdFeeCheck != 'undefined') {
              
              
			  // console.log('This is a fee product');
    			  prodFeeResult.push(true);
				localStorage.setItem('isProdFee', prodFeeResult)
                 printLabel(Fee,'product'); //Prints Label on Product bade (Custom)

                
				
			  //return true;
			} else {
			  prodFeeResult.push(false);
			  localStorage.setItem('isProdFee', prodFeeResult)
			  // return false;
			}
            
		  }
		  if (dna.data.types.includes('cart')) {
			var ProdFeeCheck = ((ShopifyAnalytics) && (ShopifyAnalytics.meta.hasOwnProperty('product'))) ? true : undefined;
			if (ProdFeeCheck) {
			  if ((dna.cart.cartprice || dna.cart.cartqty || dna.cart.cartwt)) {
				//   console.log('This is a fee product until it satisfy cart conditions.');
				prodFeeResult.push(true);
				localStorage.setItem('isProdFee', prodFeeResult)
				// return true;
				getCartConditions(dna);
				getLocConditions(dna);
			  } else {
				prodFeeResult.push(false);
				localStorage.setItem('isProdFee', prodFeeResult)
				//   console.log('Deposit fee: Cart condition satisfied.this is no longer a product fee.');
				//return false;
			  }
			} else {
			  prodFeeResult.push(false);
			  localStorage.setItem('isProdFee', prodFeeResult)
			  // return false;
			  // console.log('Deposit fee: Cart condition found but not the right page');
			}
  
  
		  }
  
  //         if(dna.data.types.includes('locations')){
  //         	if(dna.)
  //         }	
  
		  if(index==array.length-1){
			resolve(prodFeeResult);
		  }
  
		});
  
	  });
	  return logger;
  
	}
	$(document).on('cart.requestComplete', (event, cart) => {
	  //(document.querySelectorAll('button[name="checkout"]').length>=1) ? document.querySelectorAll('button[name="checkout"]').forEach((e)=>e.removeAttribute('disabled')) : false;
	});
	$(document).on('cart.requestStarted', function(event, cart) {
	  //(document.querySelectorAll('button[name="checkout"]').length>=1) ? document.querySelectorAll('button[name="checkout"]').forEach((e)=>e.setAttribute('disabled',true)) : false;
	});
	function reFactorStoreFees(StoreFees) {
	  var sF = [...StoreFees];
	  var rsF = sF.map((e) => e.auto).map((z, i) => (z) ? sF[i] : ((document.querySelector('#pfand_' + sF[i].handle)) && (document.querySelector('#pfand_' + sF[i].handle).checked)) ? sF[i] : false).filter((e) => e != false);
  
	  return rsF;
	}
		  function printLabel(Fee,type) { //this function gets called only when isProdFee ==true;
//ShopifyAnalytics.meta.product.id
          
			  if ((document.querySelector('.pfandfee_label')) && (document.querySelectorAll('#pfandfee_label_'+Fee.variant_id).length ==0) ) {
                  var nodes = document.querySelectorAll('.pfandfee_label');
                  nodes.forEach((el)=>{
                   var displayTXT = el.getAttribute('feetxt').replace('{feename}',Fee.fee_name).replace('{feeprice}',Fee.fee_price)
                  var modal =document.createElement('div');
                  modal.setAttribute('id','pfandfee_label_'+Fee.variant_id)
                  let borderColor = el.getAttribute('borderColor')
                  let bgColor = el.getAttribute('bgColor')
                    modal.innerHTML=`<div style="border: 1px solid ${borderColor}; background-color: ${bgColor}; border-radius: 8px; padding: 15px; margin-bottom: 15px; font-size: .8em; line-height: 1.3em; display: flex; flex-direction: row; justify-content: left; align-items: center;" class="associated-fee">${displayTXT}</div>`;
                  if(type=='product' && Fee.type=='multiple'){ 
                  el.appendChild(modal)
                  }
                })
			  }
		  }
function printCart(StoreFees,cartitems){
						console.log('printCart',StoreFees,cartitems);
						if(document.querySelector('.pfandfee')){
						  var el = document.querySelector('.pfandfee');
						   el.innerHTML = '';
						  StoreFees.forEach((Fee)=>{
							if(localStorage.getItem('dna_'+Fee.handle) !=null){
							  var FeeDna = JSON.parse(localStorage.getItem('dna_'+Fee.handle));
                              console.log('FeeDna',FeeDna);
							  if(FeeDna.result.matchfound && FeeDna.data.satisfied){
                                var aboutFee= cartitems.find((z)=>(z.variant_id==Fee.variant_id))	 
								  if (FeeDna.result.result.length >= 1) {
                               
                                FeeDna.result.result.forEach((fDna)=>{
                                 let li = document.createElement('p');     
								console.log('fkdna',fDna);
									var price = (aboutFee) ? ' = ' + (aboutFee.line_price / 100) + ' ' + Shopify.currency.active : '';
									var forText = Shopify.country == 'DE' ? ' zu ' : ' for ';
								  li.innerText= Fee.fee_name+forText+' "'+fDna.product_title +' x ('+ fDna.root.feequantity+')" '+price;	
                                 el.appendChild(li);     
								})
								  } else {
                                    //meaning percentagefee in cart.
								let li = document.createElement('p');
                                console.log('feel',aboutFee)
                                var currency;
                                try {
                                 currency = (theme.Currency.formatMoney().split('')[0]);
                                }catch{
                                  currency = Shopify.currency.active;
                                  }
                                  var price= (aboutFee && localStorage.getItem('percent_'+Fee.variant_id)) ? currency+' '+ (Math.round((localStorage.getItem('percent_'+Fee.variant_id)) * 100) / 100).toFixed(2):(aboutFee) ? ' '+(aboutFee.line_price/100)+' '+currency: '' ; 
                                 li.innerText= Fee.fee_name+' '+price;
                                el.appendChild(li);    
                                }
								
							  }
							}
  
						  })  
  
					  } 
	}
function cleaner(StoreFees,cartitems){
  if(ShopifyAnalytics.meta.page.pageType=='product' && ShopifyAnalytics.meta.product.type=='deposit_fee'){
 		if(appConfig.cartConfig.reloadOnUpdate){setTimeout(()=>window.location.href='/',1000)};
		return false;
	}
  if(window.location.pathname.includes('/cart')){
  	var feesInCart =cartitems.filter((e)=>e.product_type=='deposit_fee');
  	feesInCart.forEach((fee)=>{
    if((fee.properties.hasOwnProperty('id')) && (Number.isInteger(parseInt(fee.properties.id)))){
    //look for the selecte family linked id in whole cart
      if(document.querySelectorAll('[href*="'+fee.properties.id+'"]').length==0){
     //remove the fee variant
        CartJS.removeItemById(fee.key);
        console.log('Cart cleaned');
        if(localStorage.getItem('appConfig') != null ){
       var appConfig = JSON.parse(localStorage.getItem('appConfig'))
       if(appConfig.cartConfig.reloadOnUpdate){setTimeout(()=>window.location.reload(),1850)};
        }

      }
    }
  })
  }

}
	try {
	  if (localStorage.getItem('sL')) {
		localStorage.removeItem('sL');
	  } //this wil make sure to show loader only once.\
	  if (localStorage.getItem('rO')) {
		localStorage.removeItem('rO');
	  } //this wil make sure to load page only once.
	  //defining buttons
		  getCartProducts().then((r) => {
			var CartProducts = r;
			var cartitems = r.items;
            var totPrice = r.total_price/100;
			var changeinQty = cartitems.reduce((a, c) => a + c.quantity, 0);
			var totDNA = [];

      postData('https://flydiz.com/apps/depositfee/home/class/controller.php', {
		shop: Shopify.shop,
		method: 'getStoreFees'
	  }).then((r) => {
            (localStorage.getItem('showToast')) ? localStorage.removeItem('showToast'): false;
            // var StoreFees = r.response;
            var manualStoreFees = r.response.filter((e) => (e.status == 'active') && (!e.auto))
            var StoreFees = r.response.filter((e) => (e.status == 'active') && (e.auto));
            appConfig =appConfig();
            localStorage.setItem('appConfig',JSON.stringify(appConfig))
            var checkOutBtn = (document.querySelectorAll(appConfig.btn.checkOutBtn));
          	StoreFees.forEach((Fee)=>{
				applyMatch(CartProducts, Fee).then((r) => {
			  if (r.done) {
				var dna = r.response;
                console.log('dna',dna)
				applyRules(Fee, cartitems, dna)
				totDNA.push(dna);
                
				console.log('All Done!','No more changes required',dna,cartitems.length)
				if(dna.data.types.length>=1){
				 localStorage.setItem('dna_'+Fee.handle,JSON.stringify(dna));
				  checkProdFee(dna,StoreFees,CartProducts).then((isProdFee)=>{
				  if((localStorage.getItem('isProdFee') && (localStorage.getItem('isProdFee').split(',').includes('true'))) || (window.location.pathname.includes('/cart'))){
					if (ShopifyAnalytics.meta.page.hasOwnProperty('pageType') && (ShopifyAnalytics.meta.page.pageType == 'product')) { 
				  (checkOutBtn.length >= 1) ? setTimeout(()=>checkOutBtn.forEach((e) => e.style="display:none"),1700): false;
						}
					}	
				  });
				}
  
			  lastCheck(Fee,cartitems,dna);
                
			  }
			});
			});
            cleaner(StoreFees,cartitems);
              if(cartitems.some((z)=>z.product_type=='deposit_fee')){
                if (document.querySelectorAll('[name="update"]').length==0) {setInterval(()=>printCart(StoreFees,cartitems),2500); }else{setTimeout(()=>printCart(StoreFees,cartitems),1800);}       
              }
           
            $(document).ready(function() {
            			  $('body form,[id$="Popup"]').on('touchstart click', 'a[href*="quantity=0"],form,button:not([name="checkout"],[class*="toggle"],[class*="checkout"],[id*="checkout"]),input:not([class^="pfand"],[name="checkout"],[class*="checkout"],[id*="checkout"]),select', function (event) {
                            //alert(event.target.type)
                            var  hateEvents = ['search', 'text','textarea'];
							if(document.querySelectorAll('[name="update"]').length>=1){
								hateEvents = ['number',...hateEvents];
							}
				if ((!hateEvents.includes(event.target.type)) && (StoreFees.length>=1)) {
						var flag = true;
					if (event.type == "touchstart") {
						$(this).off('click');
						var timer_gear = setTimeout(()=>checker(StoreFees),2850) ;
                      	flag=false;
						console.log("Only touch event is fired",StoreFees);
					  } else if (event.type == "click") {
						$(this).off('touchstart');
						var timer_gear = setTimeout(()=>checker(StoreFees),2850) ;
						console.log("Only click event is fired");
                        flag=false;
                      }
                              
				  }
				 if(window.location.pathname.includes('/cart')){
				   (checkOutBtn.length >= 1) ? checkOutBtn.forEach((u) =>setTimeout(()=>checkOutBtn.forEach((u) => u.setAttribute('disabled',true)),1700)) : false;
                  
                 }
				
			  });
            
            
            });
		   //(checkOutBtn.length >= 1) ? checkOutBtn.forEach((u) =>checkOutBtn.forEach((u) => u.removeEventListener('click',()=>{alert()}))) : false; 
		   manualFee(manualStoreFees,CartProducts);
			//beta - //removes-the-fee-when-fee-is-present-but-family-is-not
             })
              
                  
		  });

	} catch (err) {
	}
function updatePercentFee(Fee,cartitems){
  console.log('mkc',cartitems)
if(Fee.fee_type=='percent'){
  var uPF = new Promise((rs,rj)=>{
        var nonsF =cartitems.filter((r)=> r.product_type != 'deposit_fee');
        var nonsFPrice = nonsF.reduce((a,c)=>a+(c.final_price*c.quantity),0);
     	var totPrice = ((nonsFPrice)/100);
          localStorage.setItem('percent_'+Fee.variant_id,(Fee.fee_price/100)*totPrice);
    	  localStorage.setItem('percent_totPrice',totPrice);
              postData('https://flydiz.com/apps/depositfee/home/class/controller.php', {
                shop: Shopify.shop,
                method: 'updateProd',
                pvid:Fee.variant_id,
                price:(Fee.fee_price/100)*totPrice,
              }).then((x)=>{
                
              	rs(x)
              })
  
  });
  return uPF;

           }
}
	function lastCheck(Fee,cartitems,dna){
	  
	  //this is run once all condition are satisfied.
	  //@for product  
	  // (dna.data.satisfied) - tells weather the fee given condition is satisfied? if no dont include it , if yes include it.
      
      var appConfig = JSON.parse(localStorage.getItem('appConfig'))
	  var checkOutBtn = (document.querySelectorAll(appConfig.btn.checkOutBtn));
	  var lastcheckWrongProd = (dna.data.prod.wrongProdQTY) ? dna.data.prod.wrongProdQTY.filter((f)=>(f.fee_quantity != f.linked_product_quantity) && (dna.data.satisfied)) : [];
	  //applyRules(Fee,cartitems, dna)
	  //@for product
       lastcheckWrongProd = ((lastcheckWrongProd.length==0) && (dna.data.prod.FeeCartMap) && (Fee.type=='multiple')) ? dna.data.prod.FeeCartMap.filter((f)=>(f.fee_quantity==0 || f.fee_quantity !=f.linked_product_quantity) && (dna.data.satisfied)): lastcheckWrongProd;
	  //@for cart 
      var multipleCartCond = false;
      var singleCartCond =false;
      if(Fee.type=='multiple' && dna.product != false){
        multipleCartCond =true;
      }
      if(Fee.type=='single'){
        singleCartCond =true;
      }
      if(multipleCartCond || singleCartCond){ //alow for cart check
             if(dna.cart.cartprice){
      	  lastcheckWrongProd = ((cartitems.length>=1) &&(lastcheckWrongProd.length==0) && (dna.data.cart.cartprice.result) && ((dna.data.satisfied)) && (!cartitems.map(e=>e.id).includes(dna.data.cart.cartprice.fee_variant_id))) ? [{"fee_name":dna.data.cart.cartprice.fee_name,"fee_variant_id":dna.data.cart.cartprice.fee_variant_id,"linked_product_quantity":1,"linked_product_name":'cart',fee_quantity:0}] : lastcheckWrongProd;
      }
      if(dna.cart.cartqty){
      	  lastcheckWrongProd = ((cartitems.length>=1) && (lastcheckWrongProd.length==0) && (dna.data.cart.cartqty.result) && ((dna.data.satisfied)) && (!cartitems.map(e=>e.id).includes(dna.data.cart.cartqty.fee_variant_id))) ? [{"fee_name":dna.data.cart.cartqty.fee_name,"fee_variant_id":dna.data.cart.cartqty.fee_variant_id,"linked_product_quantity":1,"linked_product_name":'cart',fee_quantity:0}] : lastcheckWrongProd;
      } 
      }

      
      //@for customer
      if(dna.customer){
      	lastcheckWrongProd=((cartitems.length>=1) && (lastcheckWrongProd.length==0) && (dna.data.customer.result) && ((dna.data.satisfied)) && (!cartitems.map(e=>e.id).includes(dna.data.customer.fee_variant_id))) ? [{"fee_name":dna.data.customer.fee_name,"fee_variant_id":dna.data.customer.fee_variant_id,"linked_product_quantity":1,"linked_product_name":'cart',fee_quantity:0}] : lastcheckWrongProd;
      }
      //@for percentage fee
      if(cartitems.find((r)=> r.variant_id ==Fee.variant_id)){
            if((lastcheckWrongProd.length==0) && (Fee.fee_type=='percent') && (cartitems.find((r)=> r.variant_id ==Fee.variant_id).price == 0 )){
        	updatePercentFee(Fee,cartitems)
      }
      }

      console.log('lastcheckWrongProd'+Fee.handle,lastcheckWrongProd);
	  if(lastcheckWrongProd.length>=1){
		var bar = new Promise((resolve, reject) => {
          
		  var done = [];
		  var singleVariant = lastcheckWrongProd.filter((e)=>e.linked_product_has_only_default_variant);
		  if(singleVariant.length>=1){
			singleVariant.forEach((e, index, array) => {
			  (checkOutBtn.length >= 1) ? setTimeout(()=>checkOutBtn.forEach((u) => u.setAttribute('disabled',true)),1700): false;
			  if(e.linked_product_has_only_default_variant){
				if(e.fee_quantity==0){
                  
				  CartJS.addItem(e.fee_variant_id,e.linked_product_quantity,{"Fee":e.fee_name+ ' for '+e.linked_product_name,"id":e.linked_product})
                  
				}else{
                  
                  (e.fee_key) ? CartJS.updateItemQuantitiesById({[e.fee_key]: (Fee.fee_feature.onetime === false)  ? e.linked_product_quantity : 1}) : CartJS.updateItemQuantitiesById({[e.fee_variant_id]: (Fee.fee_feature.onetime === false)  ? e.linked_product_quantity :1});
				}
   
				if(index==array.length-1)
				  done.push(true);
				//resolve()
  
			  }
			});
		  }
		  //else{
		  var multipleVariant = lastcheckWrongProd.filter((e)=>!e.linked_product_has_only_default_variant);
		  if(multipleVariant.length>=1){
   			
			multipleVariant.forEach((e,i,arr)=>{
              getCartProducts().then((r) => { //protector ,issue : lastcheck() and checker() runs together adding multiple times hence since checker runs first , after the qty updated we move to lastcheck where we update it with  latest qty 
                if(e.fee_quantity==0){
                 
                CartJS.addItem(e.fee_variant_id,(Fee.fee_feature.onetime === false)  ? e.linked_product_quantity : 1,{"Fee":e.fee_name+ ' for '+e.linked_product_name,"id":e.linked_product});
                }else if((r.items.find((z)=>z.id==e.fee_variant_id).quantity != e.linked_product_quantity)){
                	CartJS.updateItemQuantitiesById({[e.fee_variant_id]:0});
              			//CartJS.addItem(e.fee_variant_id,e.linked_product_quantity,{"Fee":e.fee_name+ ' for '+e.linked_product_name,"id":e.linked_product});
                }
              })
             if(Fee.fee_type=='percent'){
          		updatePercentFee(Fee,cartitems)
           }
              if(i==arr.length-1)
				done.push(true);
			  // resolve()
			})

		  }    
		  if(done.includes(true))
			resolve();
		});
		bar.then(() => {
		 (checkOutBtn.length >= 1) ? checkOutBtn.forEach((u) =>setTimeout(()=>checkOutBtn.forEach((u) => u.removeAttribute('disabled')),1700)) : false;
			if(appConfig.cartConfig.reloadOnUpdate){setTimeout(()=>window.location.reload(),1850)};
        
	  });
	  }
	}
  }
   });
  
  });
  document.head.appendChild(script);
  })();

